(function () {
  class DualPanelSlider {
    constructor(panel) {
      this.panel = panel;
      this.expand = panel.querySelector('[data-deis-panel-expand]');
      this.stage = panel.querySelector('[data-deis-panel-slider]');
      if (!this.stage) return;

      this.slides = Array.from(this.stage.querySelectorAll('.deis-slide'));
      this.dots = Array.from(this.stage.querySelectorAll('[data-deis-dot]'));

      this.currentIndex = 0;

      this.onResize = this.onResize.bind(this);

      this.dots.forEach((dot) => {
        dot.addEventListener('click', (e) => {
          e.stopPropagation();
          const idx = parseInt(dot.dataset.deisDot, 10);
          if (!isNaN(idx)) this.goTo(idx);
        });
      });

      window.addEventListener('resize', this.onResize, { passive: true });

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.onResize());
        this.ro.observe(this.expand || this.panel);
      }

      this.onResize();
      this.updateActiveSlide();
    }

    totalSlides() {
      return this.slides.length;
    }

    goTo(index) {
      const total = this.totalSlides();
      if (!total) return;
      this.currentIndex = ((index % total) + total) % total;
      this.updateDots();
      this.updateActiveSlide();
    }

    updateDots() {
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.currentIndex);
      });
    }

    onResize() {
      this.updateActiveSlide();
    }

    updateActiveSlide() {
      if (!this.slides || !this.slides.length) return;
      const total = this.totalSlides();
      const idx = ((this.currentIndex % total) + total) % total;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === idx);
      });
    }
  }

  class DualExpandingImageSlider {
    constructor(section) {
      this.section = section;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.minWidth = parseFloat(section.dataset.minWidth) || 80;
      this.maxWidth = parseFloat(section.dataset.maxWidth) || 100;

      this.currentWidth = this.minWidth;
      this.targetWidth = this.minWidth;
      this.sectionWidthPx = 0;
      this.rafLoop = null;
      this.hasUserScrolled = (window.scrollY || 0) > 2;
      this.visible = true;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.loop = this.loop.bind(this);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });

      section.querySelectorAll('[data-deis-panel]').forEach((panel) => {
        new DualPanelSlider(panel);
      });

      this.onResize();
      if (this.hasUserScrolled) {
        this.updateTarget();
        this.currentWidth = this.targetWidth;
      }
      this.applyDimensions();
      this.startLoop();

      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(
          (entries) => {
            this.visible = entries.some((e) => e.isIntersecting);
            if (this.visible) this.startLoop();
          },
          { rootMargin: '50px' }
        );
        this.io.observe(section);
      }
    }

    onResize() {
      this.sectionWidthPx = this.section.getBoundingClientRect().width;
      this.startLoop();
    }

    onScroll() {
      this.hasUserScrolled = true;
      this.updateTarget();
      this.startLoop();
    }

    updateTarget() {
      if (!this.hasUserScrolled) {
        this.targetWidth = this.minWidth;
        return;
      }
      if (this.reducedMotion) {
        this.targetWidth = this.maxWidth;
        return;
      }
      const rect = this.section.getBoundingClientRect();
      const viewport = window.innerHeight;
      const sectionHeight = rect.height;
      const totalDistance = viewport + sectionHeight;
      const traveled = viewport - rect.top;
      const progress = Math.min(1, Math.max(0, traveled / totalDistance));
      const intensity = Math.sin(progress * Math.PI);
      this.targetWidth = this.minWidth + (this.maxWidth - this.minWidth) * intensity;
    }

    startLoop() {
      if (this.rafLoop) return;
      this.rafLoop = requestAnimationFrame(this.loop);
    }

    loop() {
      if (!this.visible) {
        this.rafLoop = null;
        return;
      }

      let needsMore = false;
      const widthDiff = this.targetWidth - this.currentWidth;

      if (Math.abs(widthDiff) > 0.05) {
        this.currentWidth += widthDiff * 0.1;
        needsMore = true;
      } else {
        this.currentWidth = this.targetWidth;
      }

      this.applyDimensions();

      if (needsMore) {
        this.rafLoop = requestAnimationFrame(this.loop);
      } else {
        this.rafLoop = null;
      }
    }

    applyDimensions() {
      this.section.style.setProperty('--deis-current-width', `${this.currentWidth.toFixed(3)}%`);
    }
  }

  function initDualExpandingImageSliders() {
    document.querySelectorAll('[data-deis-section]').forEach((section) => {
      if (section.dataset.deisInitialized === 'true') return;
      section.dataset.deisInitialized = 'true';
      new DualExpandingImageSlider(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDualExpandingImageSliders);
  } else {
    initDualExpandingImageSliders();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('[data-deis-section]')) {
      initDualExpandingImageSliders();
    }
  });
})();
